module.exports = __webpack_public_path__ + "img/pay-method-rounded.5ad138ea.svg";